import React from 'react'
import PropTypes from 'prop-types'
import { t } from 'i18n'

import ActivityHeader from './ActivityHeader'
import Comments from './Comments'
import LinkDecorator from 'Components/Base/LinkDecorator'

const i18nOpts = { scope: 'activity_feed.prescription' }

const Prescription = ({ id, createdAt, link, author, comments, text, type, isComplete, carePlanUuid }) => (
  <div className="activity">
    <ActivityHeader createdAt={createdAt} type={type} link={link} {...author} />

    <div className="activity__body">
      <p>
        <LinkDecorator>{text}</LinkDecorator>
      </p>

      <p>
        <span>{t('status', i18nOpts)}</span>
        {isComplete ? (
          <span className="activity__status activity__status--complete">{t('filled', i18nOpts)}</span>
        ) : (
          <span className="activity__status activity__status--incomplete">{t('to_be_filled', i18nOpts)}</span>
        )}
      </p>
    </div>

    <hr />

    <Comments comments={comments} parentId={id} carePlanUuid={carePlanUuid} />
  </div>
)

Prescription.propTypes = {
  author: PropTypes.object.isRequired,
  carePlanUuid: PropTypes.string.isRequired,
  comments: PropTypes.array,
  createdAt: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
}

Prescription.defaultProps = {
  comments: [],
}

export default Prescription
